import type { Ref } from "react"
import { cn } from "@/lib/utils"

type Side = "right" | "left" | "bottom"

const sideClasses: Record<Side, string> = {
  right: "top-[28%] right-0 translate-x-1/2 -translate-y-1/2 border-t border-r",
  left: "top-[28%] left-0 -translate-x-1/2 -translate-y-1/2 border-b border-l",
  bottom:
    "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 border-r border-b",
}

type Props = {
  side?: Side
  className?: string
  ref?: Ref<HTMLSpanElement>
}

export function BubbleTail({ side = "bottom", className, ref }: Props) {
  return (
    <span
      ref={ref}
      aria-hidden="true"
      className={cn(
        "absolute hidden size-4 rotate-45 border-white/15 bg-background/45 backdrop-blur-sm md:block",
        sideClasses[side],
        className
      )}
    />
  )
}
